export const router = {
  path: "youyueAbility",
  name: "youyueAbility",
  meta: {
    title: "优越能力",
    title_en: "ABILITY",
    showOnNavMenu: true,
    navMenuMode: "custom",
    iconfont: "icon-chanpin",
    dropDown: true,
    subBar: true,
  },
  redirect() {
    return { name: "intro" };
  },
  children: [
    {
      path: "intro",
      name: "intro",
      meta: {
        title: "公司简介",
        showOnNavMenu: true,
      },
      component: () => import("@/views/ability/intro/index.vue"),
    },
    {
      path: "operation",
      name: "operation",
      meta: {
        title: "运营团队",
        showOnNavMenu: true,
      },
      component: () => import("@/views/ability/operation/index.vue"),
    },
    {
      path: "researchTeam",
      name: "researchTeam",
      meta: {
        title: "科研设施",
        showOnNavMenu: true,
      },
      component: () => import("@/views/ability/researchTeam/index.vue"),
    },
    {
      path: "scienceResources",
      name: "scienceResources",
      meta: {
        title: "科创资源",
        showOnNavMenu: true,
      },
      component: () => import("@/views/ability/scienceResources/index.vue"),
    },
    {
      path: "business",
      name: "business",
      meta: {
        title: "业务能力",
        showOnNavMenu: true,
      },
      component: () => import("@/views/ability/business/index.vue"),
    },
    {
      path: "partners",
      name: "partners",
      meta: {
        title: "合作伙伴",
        showOnNavMenu: true,
      },
      component: () => import("@/views/ability/partners/index.vue"),
    },
    {
      path: "cooperationCases",
      name: "cooperationCases",
      meta: {
        title: "合作案例",
        showOnNavMenu: true,
      },
      component: () => import("@/views/ability/cooperationCases/index.vue"),
    },
  ],
};
